import { MaintenanceWindowPreviewPatchManagementView } from '../view/MaintenanceWindowPreviewPatchManagementView';
import { templateMaintenanceWindowPreviewPatchManagement } from '../view/template';
import { MaintenanceWindowPreviewPatchManagementRepository } from '../repository/MaintenanceWindowPreviewPatchManagementRepository';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { MaintenanceWindowPreviewPatchManagementWebComponent } from '..';
import { MaintenanceWindowPreviewPatchManagementWebComponentSchema } from '../types';
import { queueAsyncMethodCalls } from '../../../utils/queueAsyncMethodCalls.utils';

export class MaintenanceWindowPreviewPatchManagementController extends BaseWebComponentController {
  public component: MaintenanceWindowPreviewPatchManagementWebComponent;
  public dataRepository: MaintenanceWindowPreviewPatchManagementRepository;
  public view: MaintenanceWindowPreviewPatchManagementView;
  public viewConstructor: typeof MaintenanceWindowPreviewPatchManagementView;
  public dataRepositoryConstructor: typeof MaintenanceWindowPreviewPatchManagementRepository;

  constructor(component: MaintenanceWindowPreviewPatchManagementWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MaintenanceWindowPreviewPatchManagementView,
      viewTemplate: templateMaintenanceWindowPreviewPatchManagement,
      dataRepositoryConstructor: MaintenanceWindowPreviewPatchManagementRepository,
    });
  }

  async getDataForView(): Promise<MaintenanceWindowPreviewPatchManagementWebComponentSchema | null> {
    const view = this.view;

    // Remove previous template states
    view.removeAllStates();

    // Set empty values in template
    view.clearTemplateValues();

    if (this.component.maintenanceWindowId === '') {
      return null;
    }

    // Set loading
    view.setLoadingState();

    const reponse = await this.dataRepository.getDataForView(this.component.maintenanceWindowId);

    // Remove loading
    view.removeAllStates();

    return reponse;
  }

  @queueAsyncMethodCalls
  async render() {
    super.render();
  }
}
